import { AboutPage } from "../components"

export default AboutPage
